import React, { useContext } from "react";
import { useFcardContact } from "./hooks/FcardContact";
import styles from "./style/FcardContact.module.scss";
import { AuthContext } from "../../context/AuthContext";
import { Trash, TrashOutline } from "react-ionicons";
import FiconPhoneNumber from "../FiconPhoneNumber/FiconPhoneNumber";
/* This example requires Tailwind CSS v2.0+ */

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const FcardContact = ({ onDeleteMembers = () => { }, preferredName = "", phoneNumber = "", className = "",backgroundInitial}) => {
  return (

    <div
      key={preferredName}
      className={ `col-span-1 flex shadow-Box rounded-xl mb-3 w-full ${className}`}
    >
      <div
        style={{
          backgroundColor: backgroundInitial,
        }}
        className={classNames(
          "flex-shrink-0 flex items-center justify-center w-16 text-white text-sm font-medium rounded-l-md uppercase"
        )}
      >
        {preferredName
          .replace(/[A-Za-z]+/g, function (match) {
            return match.trim()[0];
          })
          .replace(/\s/g, "")
          .slice(0, 2)}
      </div>
      <div className="flex-1 flex items-center justify-between border-t border-r border-b border-gray-200 bg-white rounded-r-md truncate">
        {phoneNumber == "" ? (<div className="flex-1 px-4 py-5 text-sm truncate">
          <a className="text-gray-900 font-bold hover:text-gray-600 capitalize">
            {preferredName}
          </a>
        </div>) : (<div className="flex-1 px-4 py-2 text-sm truncate">
          <a className="text-gray-900 font-bold hover:text-gray-600 capitalize">
            {preferredName}
          </a>
          <p className="text-gray-500 font-regular">
            <FiconPhoneNumber
              sizeIcon="20px"
              phoneNumber={phoneNumber}
            />
          </p>
        </div>)
        }

        <div className="col-span-1 pr-4 flex place-content-center items-center justify-end cursor-pointer">
          <Trash
            height="27px"
            width="27px"
            color={"#E30000"}
            onClick={onDeleteMembers}
          />
        </div>
      </div>
    </div>
  );
};

export default FcardContact;
